import apiRequest from "@/services/api-request";
import { loadgingState } from "@/store/loading";
import { useCallback } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useTranslation } from "react-i18next";
import { ResponseType } from "axios";
import { loadingWithShadowState } from "@/store/loading-with-shadow";
import {
  isLoggedInState,
  tokenExpiredState,
} from "@/store/token-expired-modal";
import { HttpErrorCodes } from "@/enums/error-types";

const useGomakeAxios = () => {
  const setLoading = useSetRecoilState(loadgingState);
  const setLoadingWithShadow = useSetRecoilState(loadingWithShadowState);
  const { t } = useTranslation();
  const language = t("language");
  // const { push } = useRouter();
  const showLoginModal = useSetRecoilState(tokenExpiredState);
  const [isLoggedIn, setIsLoggedIn] = useRecoilState(isLoggedInState);
  const callApi = useCallback(
    async (
      method: string,
      url: string,
      data?: any,
      lockScreen: boolean = true,
      requestAbortController: AbortController = null,
      responseType?: ResponseType,
      withShadow = false
    ) => {
      if (lockScreen) {
        if (withShadow) {
          setLoadingWithShadow(true);
        } else {
          setLoading(true);
        }
      }
      try {
        const result = await apiRequest(
          method,
          url,
          data,
          language,
          requestAbortController,
          responseType
        );
        const isLoginRequest = url.includes("/auth/login-customer");
        if (
          result?.status === HttpErrorCodes.UNAUTHORIZED &&
          isLoggedIn &&
          !isLoginRequest
        ) {
          setIsLoggedIn(false);
          showLoginModal(true);
          return;
        }
        return result;
      } finally {
        // Always clear the global lock — otherwise a hung/failed ERP call freezes GoMake.
        if (lockScreen) {
          if (withShadow) {
            setLoadingWithShadow(false);
          } else {
            setLoading(false);
          }
        }
      }
    },
    [
      isLoggedIn,
      language,
      setIsLoggedIn,
      setLoading,
      setLoadingWithShadow,
      showLoginModal,
    ]
  );

  return { callApi };
};

export { useGomakeAxios };
